import { global } from "../../constants";

export const data = {
    banner: {
        background: global.banner + "contactus.webp",
        title: "Contact Us",
        base: "Home",
        crumb: "Contact Us",
        sendMessage: "Send us a message",
        submitNow: "Send Now",
        contactUs: "Get in touch",
        name: "Name",
        email: "Email Address",
        phone: "Phone Number",
        subject: "Subject",
        message: "Message",
    }
}